import React from 'react';
import { useTranslation } from 'react-i18next';
import { useEvaluationStore } from '../../../store/evaluationStore';
import { useUserSettingsStore } from '../../../store/userSettingsStore';
import { decryptProductTitle } from '../../../utils/encryption';
import './CompactEdit.css';

interface CompactEditProps {
  productIndex: number;
  className?: string;
}

export const CompactEdit: React.FC<CompactEditProps> = ({
  productIndex,
  className = ''
}) => {
  const { t } = useTranslation();
  const { products } = useEvaluationStore();
  const { userSettings } = useUserSettingsStore();
  const [decryptedTitle, setDecryptedTitle] = React.useState('');
  
  const product = products[productIndex];
  const securityModeEnabled = userSettings?.securityMode || false;

  React.useEffect(() => {
    const decryptTitle = async () => {
      if (!product) return;
      
      if (securityModeEnabled && userSettings?.privateKey) {
        try {
          const decrypted = await decryptProductTitle(product.reviewTitle, userSettings.privateKey);
          setDecryptedTitle(decrypted);
        } catch (error) {
          setDecryptedTitle(product.reviewTitle);
        }
      } else {
        setDecryptedTitle(product.reviewTitle);
      }
    };
    
    decryptTitle();
  }, [product, securityModeEnabled, userSettings?.privateKey]);

  if (!product) return null;

  return (
    <div className={`compact-edit ${className}`}>
      <div className="compact-edit__header">
        <h4 className="compact-edit__title">{decryptedTitle}</h4>
      </div>
      <div className="compact-edit__content">
        <div className="compact-edit__field">
          <label className="compact-edit__label">{t('productRegistration.form.titleLabel')}</label>
          <div className="compact-edit__value">{decryptedTitle}</div>
        </div>
        
        {product.reviewLink && (
          <div className="compact-edit__field">
            <label className="compact-edit__label">{t('productRegistration.form.linkLabel')}</label>
            <a 
              href={product.reviewLink} 
              target="_blank" 
              rel="noopener noreferrer"
              className="compact-edit__link"
            >
              {product.reviewLink}
            </a>
          </div>
        )}
        
        {product.reviewComment && (
          <div className="compact-edit__field">
            <label className="compact-edit__label">{t('productRegistration.form.detailLabel')}</label>
            <div className="compact-edit__value compact-edit__value--multiline">
              {product.reviewComment}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};